/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { CategoryCard } from "./CategoryCard";
import { SearchBar } from "./SearchBar";
import { CategoriesList } from "./CategoriesList";
import { ProductList } from "../productos/ProductList";
import { foodService } from "../../services/foodService";
import { categoryService } from "../../services/categoryService";
import LoadingSpinner from "../common/LoadingSpinner";
import ErrorAlert from "../common/ErrorAlert";

export const SearchSection = ({ onQuantityChange, getCurrentQuantity }) => {
  const [activeSection, setActiveSection] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState({ drinks: [], kitchen: [] });
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCategories();
    fetchProducts();
  }, []);

  // Efecto para el término de búsqueda
  useEffect(() => {
    if (searchTerm.length >= 2) {
      const filtered = products.filter(
        (product) =>
          product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          product.description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  }, [searchTerm, products]);

  // Efecto modificado para filtrar por nombre de categoría
  useEffect(() => {
    if (selectedCategory) {
      const filtered = products.filter((product) => {
        // Comparación case-insensitive
        return (
          product.category.toLowerCase() === selectedCategory.name.toLowerCase()
        );
      });

      console.log("Productos filtrados:", filtered);
      setFilteredProducts(filtered);
    }
  }, [selectedCategory, products]);

  const fetchCategories = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await categoryService.listCategories();

      if (result.success) {
        setCategories(result.data);
      } else {
        setError("Error al cargar las categorías: " + result.message);
      }
    } catch (err) {
      setError("Error al cargar las categorías");
      console.error("Error al cargar categorías:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchProducts = async () => {
    try {
      const result = await foodService.listFoods();

      if (result.success) {
        setProducts(result.data);
      } else {
        setError("Error al cargar los productos: " + result.message);
      }
    } catch (err) {
      setError("Error al cargar los productos");
      console.error("Error al cargar productos:", err);
    }
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setSelectedCategory(null);
  };

  const handleSectionClick = (section) => {
    setActiveSection((prev) => (prev === section ? null : section));
    setSearchTerm("");
    setSelectedCategory(null);
    setFilteredProducts([]);
  };

  const getCurrentCategories = () => {
    if (!categories) return [];
    if (activeSection === "bebidas") {
      return categories.drinks || [];
    }
    if (activeSection === "comidas") {
      return categories.kitchen || [];
    }
    return [];
  };

  if (
    isLoading &&
    !products.length &&
    !categories.drinks.length &&
    !categories.kitchen.length
  ) {
    return <LoadingSpinner />;
  }

  if (error) {
    return (
      <ErrorAlert
        message={error}
        onRetry={() => {
          fetchCategories();
          fetchProducts();
        }}
      />
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between w-full">
        <CategoryCard
          size="w-[15%]"
          icon="🍽️"
          title="COMIDAS"
          isActive={activeSection === "comidas"}
          onClick={() => handleSectionClick("comidas")}
        />
        <SearchBar
          onSearch={handleSearch}
          value={searchTerm}
          placeholder="Buscar productos..."
        />
        <CategoryCard
          size="w-[15%]"
          icon="🍺"
          title="BEBIDAS"
          isActive={activeSection === "bebidas"}
          onClick={() => handleSectionClick("bebidas")}
        />
      </div>

      {searchTerm.length >= 2 && (
        <div className="mt-4">
          <h3 className="text-lg font-semibold mb-4 flex justify-between items-center">
            <span>Resultados de búsqueda</span>
            <span className="text-sm text-gray-500">
              {filteredProducts.length} productos encontrados
            </span>
          </h3>
          <ProductList
            products={filteredProducts}
            onQuantityChange={onQuantityChange}
            getCurrentQuantity={getCurrentQuantity}
          />
        </div>
      )}

      {!searchTerm && activeSection && (
        <div className="mt-4">
          <h3 className="text-lg font-semibold mb-4">
            Categorías de {activeSection === "comidas" ? "Comidas" : "Bebidas"}
          </h3>
          <CategoriesList
            categories={getCurrentCategories()}
            onCategorySelect={(category) => {
              console.log(
                "Categoría seleccionada en CategoriesList:",
                category
              );
              setSelectedCategory(category);
            }}
            activeCategory={selectedCategory}
          />
        </div>
      )}

      {!searchTerm && selectedCategory && (
        <div className="mt-4">
          <h3 className="text-lg font-semibold mb-4">
            Productos de {selectedCategory.name}
          </h3>
          <ProductList
            products={filteredProducts}
            onQuantityChange={onQuantityChange}
            getCurrentQuantity={getCurrentQuantity}
          />
          {filteredProducts.length === 0 && (
            <div className="text-center py-8 text-gray-500">
              No hay productos disponibles en esta categoría
            </div>
          )}
        </div>
      )}
    </div>
  );
};